module.exports = __webpack_public_path__ + "img/RGS.547ef19f.png";